export default __webpack_public_path__ + "static/media/image1historia.8fb7ae91.jpeg";